const Keys = {
    Maps: 'AIzaSyAlBBMFW4iwb9iS-u7m7ckDGgkeezrsbw4',
};

export { Keys };